import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";
import { MultiSelect } from "@/components/modals/MultiSelect";
import { useAdminContext } from "@/context/AdminContext";
import { useAppContext } from "@/context/AppContext";
import { useLanguage } from "@/context/LanguageContext";

export function SwitchUsers() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      title: "Přepnout uživatele",
      description: "Zjistím, jak to vypadá u ostatních",
      placeholder: "Vyber ze seznamu",
    },
    en: {
      title: "Switch user",
      description: "See how it looks for others",
      placeholder: "Choose from the list",
    },
  }[language];
  const { emailList, switchToUser } = useAdminContext();
  const { isLoading } = useAppContext();

  return (
    <DialogContent className="sm:max-w-[425px]">
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
        className="space-y-4"
      >
        <DialogHeader>
          <DialogTitle>{copy.title}</DialogTitle>
          <DialogDescription>{copy.description}</DialogDescription>
        </DialogHeader>

        <div className="grid gap-3 py-4">
          <div className="app-form-row">
            <MultiSelect
              options={emailList}
              selected={[]}
              setSelected={(values) => {
                const selectedEmail = values.at(-1);

                if (!selectedEmail) {
                  return;
                }

                switchToUser(selectedEmail);
              }}
              disabled={isLoading}
              selectionMode="single"
              showSearch={false}
              placeholder={copy.placeholder}
              className="col-span-4 mb-0 w-full"
            />
          </div>
        </div>
      </form>
    </DialogContent>
  );
}
